// src/pages/AntiTrustPage.js
import React from 'react';
import Footer from '../components/Footer';       // Footer at bottom
import ContactForm from '../components/ContactForm'; // Your contact form
import './AntiTrustPage.css';                     // Styles for this page
import '../index.css';                          // General styles

// Optional: If you have a specific logo or hero image for this page, import it here
// import antiTrustLogo from '../assets/antiTrustLogo.png';
// import antiTrustHeroImage from '../assets/antiTrustHeroImage.jpg';

const AntiTrustPage = () => {
  return (
    <>
      {/* Main content */}
      <main className="antiTrustPageContainer">
        <section className="antiTrustHero">
          {/* H1 Title */}
          <h1 className="antiTrustTitle">
            Nexed Insight Anti-Trust Statement
          </h1>

          {/* Optional: If you have a logo for this page */}
          {/* <img src={antiTrustLogo} alt="Anti-Trust" className="antiTrustLogo" /> */}

          {/* Introductory Paragraph */}
          <p className="antiTrustIntro">
            At Nexed Insight, we are committed to upholding the highest
            standards of competition law and anti-trust compliance. As a research and
            advisory platform operating in close partnership with a diverse range of
            business schools, corporate learning leaders, and sector stakeholders, we take
            our responsibility seriously to support a fair, open, and dynamic market for business
            education.
          </p>
          <p className="antiTrustIntro">
            To that end, we affirm the following principles:
          </p>
        </section>

        {/* Optional: Hero Image spanning the full page width (if you want one) */}
        {/*
        <section className="antiTrustHeroImageWrapper">
          <img src={antiTrustHeroImage} alt="Anti-Trust Compliance" className="antiTrustHeroImage" />
        </section>
        */}

        <section className="antiTrustPrinciples">
          <div className="antiTrustPrinciple">
            <h2>Championing Competition and Innovation</h2>
            <p>
              Nexed Insight exists to promote innovation, differentiation, and healthy
              competition across the business education landscape. Our core objective is
              to enhance choice, impact, and value for clients and learners — not to
              restrict it.
            </p>
          </div>

          <div className="antiTrustPrinciple">
            <h2>Reflecting Market Diversity</h2>
            <p>
              Our work will actively reflect and celebrate the full spectrum of
              providers in the market — from globally established institutions to
              emerging players and non-traditional innovators — ensuring all voices are
              represented.
            </p>
          </div>

          <div className="antiTrustPrinciple">
            <h2>Maintaining an Open, Transparent Platform</h2>
            <p>
              Nexed Insight is an outward-facing platform designed to foster inclusive
              dialogue between supply- and demand-side actors. We categorically reject
              and will not support any form of collusion, exclusionary practice, or
              closed-shop behavior.
            </p>
          </div>

          <div className="antiTrustPrinciple">
            <h2>Avoiding Sensitive Competitive Data</h2>
            <p>
              We do not and will not conduct or publish research that involves
              commercially sensitive or potentially anti-competitive data — such as
              faculty compensation, program pricing, or any benchmarking that could
              distort normal market competition.
            </p>
          </div>

          <div className="antiTrustPrinciple">
            <h2>Encouraging Diverse Approaches, Not Alignment</h2>
            <p>
              Our content and advisory work will always encourage innovation,
              experimentation, and responsiveness to client needs. We will never
              advocate for homogenization or undue alignment in the strategies or
              offerings of providers.
            </p>
          </div>
        </section>

        <section className="antiTrustConclusion">
          <p>
            Nexed Insight’s research, partnerships, and communications
            are designed to support continuous improvement and strategic foresight, while
            always respecting and reinforcing the principles of open competition.
          </p>
          <p>
            For any questions regarding our anti-trust policy or to
            report concerns, please contact: <a href="mailto:plejoncour@iedp.com">plejoncour@iedp.com</a>
          </p>
        </section>

        {/* Contact Form */}
        <ContactForm />
      </main>

      {/* Footer at the bottom */}
      <Footer />
    </>
  );
};

export default AntiTrustPage;